import { updateObject } from "../../helpers/index";
import * as aTypes from "../actions/actionTypes";

const initialState = {
  products: null,
  products_error: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case aTypes.PRODUCTS_SET:
      return fetchProductsSuccess(state, action);
    case aTypes.PRODUCTS_FETCH_FAIL:
      return fetchProductsFail(state, action);
    default:
      return state;
  }
};

// =========== MY PRODUCTS FREE
const fetchProductsSuccess = (state, action) => {
  return updateObject(state, {
    products: action.data,
  });
};

const fetchProductsFail = (state, action) => {
  return updateObject(state, {
    products_error: action.error,
  });
};

export default reducer;
